/* eslint-disable */
import React, { Component } from "react";
import { Heading, VStack } from "@chakra-ui/react";
import { connect } from "react-redux";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { show } from "redux-modal";
import { getEnums } from "../../utils/store/actions/survey.action";
import { withTranslation } from "react-i18next";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import BusinessIcon from "@material-ui/icons/Business";
import {
  getAllIssuerSigners,
  getAllProductSigners,
  deleteIssuerSigner,
  deleteProductSigner,
  updateIssuerSigner,
  updateProductSigner,
  updatePersonSigner,
  getFund,
} from "../../utils/store/actions/funds.actions";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { Button, Card } from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import ModalSigners from "../../components/Modal/Modal.Signers";

const styles = (theme: Theme) =>
  createStyles({
    divFundList: {
      margin: "2%",
      backgroundColor: "white",
      borderRadius: "10px",
      padding: "10px",
      boxShadow: "none",
    },
    root: {
      width: "100%",
      backgroundColor: theme.palette.background.paper,
      maxHeight: 400,
      overflow: "auto",
    },
    createSigners: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      margin: "2%",
    },
    buttonSigners: {
      color: "white",
      backgroundColor: "#ae0064",
      margin: "10%",
      textTransform: "none",
    },
    issuersTitle: {
      display: "flex",
      width: "100%",
      justifyContent: "space-between",
      margin: "1%",
      padding: "1%",
    },
    moreButton: {
      textTransform: "none",
      color: "#97A0C3",
      fontWeight: "bolder",
      padding: "0px",
      fontSize: "16px",
    },
    arrowRight: { fontSize: "20px", fontWeight: "bolder", padding: "0px" },
    listItem: {
      border: "1px solid #EAEDF7",
      borderRadius: "12px",
      marginBottom: "10px",
      boxShadow: "0px 2px 4px rgba(28, 41, 90, 0.0367952)",
      "&:hover": {
        cursor: "pointer",
        background: "#F5F6FF",
      },
    },
  });

class FundSignerList extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      checked: true,
    };
  }

  queryString = window.location.search;
  urlParams = new URLSearchParams(this.queryString);
  fundPersonId = this.urlParams.get("id");

  updateIssuerSigner = (checked: any, signer: any) => {
    this.props
      .updateIssuerSigner(signer.id, this.fundPersonId, signer, checked)
      .then(() => {
        this.props.getAllIssuerSigners(this.fundPersonId);
      });
  };
  updateProductSigner = (checked: any, signer: any) => {
    this.props
      .updateProductSigner(signer.id, this.fundPersonId, signer, checked)
      .then(() => {
        this.props.getAllProductSigners(this.fundPersonId);
      });
  };
  handleDeleteIssuerSigner = (signerId: any) => {
    this.props.deleteIssuerSigner(signerId, this.fundPersonId).then(() => {
      this.props.getAllIssuerSigners(this.fundPersonId);
    });
  };

  handleDeleteProductSigner = (signerId: any) => {
    this.props.deleteProductSigner(signerId, this.fundPersonId).then(() => {
      this.props.getAllProductSigners(this.fundPersonId);
    });
  };

  render() {
    const { classes } = this.props;
    const { Funds } = this.props;
    const { t } = this.props;

    return (
      <>
        <ModalSigners />
        <div className={classes.createSigners}>
          <Button
            variant="contained"
            className={classes.buttonSigners}
            onClick={() =>
              this.props.show("create_update_signer", {
                name: "create_update_signer",
                history,
                actionDone: "CREATE",
                signerType: "ISSUER",
              })
            }
          >
            {t("ADD_AN_ISSUER_SIGNER")}
          </Button>
        </div>
        <Card className={classes.divFundList}>
          <VStack>
            <div className={classes.issuersTitle}>
              <Heading
                fontSize="16px"
                color="black"
                fontWeight="bolder"
                fontFamily="ABeeZee"
                mb={2}
                mt={2}
                style={{ alignItems: "center" }}
              >
                {t("ISSUERS")}
              </Heading>
              <Button
                className={classes.moreButton}
                onClick={() =>
                  this.props.show("signers_modal", {
                    name: "signers_modal",
                    history,
                    actionDone: "SHOW",
                    signerType: "ISSUER",
                  })
                }
              >
                {t("MORE")}
                <ChevronRightIcon className={classes.arrowRight} />
              </Button>
            </div>
          </VStack>
          <div style={{ color: "black", fontWeight: "bolder" }}>
            {t("RECENT_SIGNERS")}
          </div>
          <List
            style={{ maxHeight: 400, overflow: "auto" }}
            className={classes.root}
          >
            {Funds?.issuer_fund_signers_list?.length !== 0 ? (
              Funds?.issuer_fund_signers_list?.map((signer: any) => {
                return (
                  <>
                    <ListItem
                      className={classes.listItem}
                      key={signer.id}
                      onClick={(e: any) => {
                        e.stopPropagation();
                        this.props.show("create_update_signer", {
                          name: "create_update_signer",
                          history,
                          signer: signer,
                          enums: this.props.Surveys.enums,
                          signerType: "ISSUER",
                          actionDone: "UPDATE",
                        });
                      }}
                    >
                      <ListItemAvatar>
                        <Avatar style={{ backgroundColor: "#242F57" }}>
                          {signer.personType === "INDIVIDUAL" ? (
                            <PersonOutlineIcon />
                          ) : (
                            <BusinessIcon />
                          )}
                        </Avatar>
                      </ListItemAvatar>

                      <ListItemText
                        id={signer.id}
                        primary={
                          signer.firstName
                            ? `${signer.firstName} ${signer.name}`
                            : `${signer.name}`
                        }
                      />
                      <ListItemSecondaryAction>
                        {" "}
                        <DeleteOutlinedIcon
                          style={{ color: "#97A0C3" }}
                          onClick={() => {
                            this.handleDeleteIssuerSigner(signer.id);
                          }}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  </>
                );
              })
            ) : (
              <div>--</div>
            )}
          </List>
        </Card>
        <div className={classes.createSigners}>
          <Button
            variant="contained"
            className={classes.buttonSigners}
            onClick={() =>
              this.props.show("create_update_signer", {
                name: "create_update_signer",
                history,
                actionDone: "CREATE",
                signerType: "PRODUCT",
              })
            }
          >
            {t("ADD_A_PRODUCT_SIGNER")}
          </Button>
        </div>
        <Card className={classes.divFundList}>
          <VStack>
            <div className={classes.issuersTitle}>
              <Heading
                fontSize="16px"
                color="black"
                fontWeight="bolder"
                fontFamily="ABeeZee"
                mt={2}
                mb={2}
              >
                {t("PRODUCT_SIGNERS")}
              </Heading>
              <Button
                className={classes.moreButton}
                onClick={() =>
                  this.props.show("signers_modal", {
                    name: "signers_modal",
                    history,
                    actionDone: "SHOW",
                    signerType: "PRODUCT",
                  })
                }
              >
                {t("MORE")}
                <ChevronRightIcon className={classes.arrowRight} />
              </Button>
            </div>
          </VStack>
          <div style={{ color: "black", fontWeight: "bolder" }}>
            {t("RECENT_SIGNERS")}
          </div>
          <List
            style={{ maxHeight: 400, overflow: "auto" }}
            className={classes.root}
          >
            {Funds?.product_fund_signers_list?.length !== 0 ? (
              Funds?.product_fund_signers_list?.map((signer: any) => {
                return (
                  <>
                    <ListItem
                      className={classes.listItem}
                      key={signer.id}
                      onClick={() => {
                        this.props.show("create_update_signer", {
                          name: "create_update_signer",
                          history,
                          signer: signer,
                          enums: this.props.Surveys.enums,
                          signerType: "PRODUCT",
                          actionDone: "UPDATE",
                        });
                      }}
                    >
                      <ListItemAvatar>
                        <Avatar style={{ backgroundColor: "#242F57" }}>
                          {signer.personType === "INDIVIDUAL" ? (
                            <PersonOutlineIcon />
                          ) : (
                            <BusinessIcon />
                          )}
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        id={signer.id}
                        primary={
                          signer.firstName
                            ? `${signer.firstName} ${signer.name}`
                            : `${signer.name}`
                        }
                      />
                      <ListItemSecondaryAction>
                        {" "}
                        <DeleteOutlinedIcon
                          style={{ color: "#97A0C3" }}
                          onClick={() => {
                            this.handleDeleteProductSigner(signer.id);
                          }}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  </>
                );
              })
            ) : (
              <div>--</div>
            )}
          </List>
        </Card>
      </>
    );
  }
}
const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getAllIssuerSigners,
  getAllProductSigners,
  deleteIssuerSigner,
  deleteProductSigner,
  updateIssuerSigner,
  updateProductSigner,
  updatePersonSigner,
  getFund,
  getEnums,
  show,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(FundSignerList)));
